import React from "react";
import { Routes, Route } from "react-router-dom";
import About from "../Pages/About";
import Contact from "../Pages/Contact";
import Dashboard from "../Components/Dashboard/Dashboardlayout";
import AuthWrapper from "../Components/LoginAuth/AuthWrapper";
import HomePage from "../Pages/HomePage";
import MainLayout from "../Components/Layout/MainLayout";
import DashboardLayout from "../Components/Dashboard/Dashboardlayout";
import FAQs from "../Pages/FAQs";
import OurTeam from "../Pages/Teams/OurTeam";
import BookNow from "../Pages/BookNow";
import Careers from "../Pages/Careers";
import WalkInJobSearch from "../Pages/Jobs/WalkInJobSearch";
import FlightStatus from "../Pages/FlightStatus";
import NotFound from "../Pages/NotFound";
import Engineering from "../Pages/Engineering";

const Approutes = () => {
  return (
    <>
      <Routes>
        {/* Main layout with header & footer */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booknow" element={<BookNow />} />
          <Route path="/service1" element={<FlightStatus />} />
          <Route path="/faq" element={<FAQs />} />
          <Route path="/ourTeam" element={<OurTeam />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/walk-in-jobs" element={<WalkInJobSearch />} />
          <Route path="/engineering" element={<Engineering />} />
        </Route>
        {/* Auth routes (no footer) */}
        <Route path="/auth" element={<AuthWrapper />} />

        {/* Dashboard layout with no header and footer */}
        <Route path="/dashboard/*" element={<DashboardLayout />}></Route>
        <Route path="/dashboard" element={<Dashboard />} />
        {/* 404 Route - Must be LAST */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default Approutes;
